export function titleMediaPath(productId: string, mediaId: string): string {
  return `/v1/content/title-media/${productId}/${mediaId}`;
}

export function titleMediaPosterPath(productId: string, mediaId: string): string {
  return `/v1/content/title-media/${productId}/${mediaId}/poster`;
}
